<template>
    <div class="zt-page-content" ref="load">
        <div v-if="item" class="container flex">
            <div class="detail-left flex-1">
                <div class="detail-top">
                    <div class="top flex">
                        <div class="info-img">
                            <img src="@/assets/images/desgin/icon_series.png">
                        </div>
                        <div class="detail-info flex-1">
                            <div class="info-name ellipsis1">
                                <b>{{item.name}}</b>
                            </div>
                            <div class="style">
                                <span v-if="item.style">{{item.style.name}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="bottom flex">
                        <div v-if="item.photos && item.photos.length>0" class="img-carousel">
                            <ItemImages :imgs="item.photos" :preUrl="IMG_URL_PRE" width="400px"></ItemImages>
                        </div>
                    </div>
                </div>
                <div class="detail-bottom">
                    <div class="tab_menu flex">
                        <div v-for="(item,index) in tabList" :key="index" @click="tab(index)" class="menu_item" :class="{'cur':tabIndex == index}">
                            {{item.name}}
                        </div>
                    </div>
                    <div v-if="tabList && tabList.length>0" class="db-box">
                        <div class="db-box-item" v-for="(item,idx) in tabList" :key="idx">
                            <div v-if="tabIndex==idx" class="flex">
                                <div class="dbb-item" @click="gotoProduct(row.id)" v-for="(row,idx1) in item.product_rows" :key="idx1">
                                    <div v-if="row.photo_render && row.photo_render.length>0">
                                        <img :src="(IMG_URL_PRE || '')+row.photo_render[0]+'!width_250px'">
                                    </div>
                                    <div class="text ellipsis2">{{row.name}}</div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                    
                </div>
            </div>
            <div v-if="type!=1" class="detail-right">
                <div class="dr-info">
                    <div>作品属性：
                        <span v-if="item.price_type==0">设计版权出售</span>
                        <span v-if="item.price_type==1">分成合作</span>
                        <span v-if="item.price_type==3">需求定制</span>
                        <span v-if="item.price_type==4">暂不上架</span>
                    </div>
                    <div v-if="item.price_type==0" class="contract_view">
                        <el-button @click="contract_view(item)" type="text">查看合同</el-button>
                    </div>
                    <div>一口价：
                        <span class="price">￥{{item.price | priceFilt}}</span>
                    </div>
                    <div v-if="item.trans_stat>0">当前状态：
                        <span style="color:#F66F6A;">该套系已被（他人）签约</span>
                    </div>
                    <div v-else>
                        <el-button @click="gotoSign(item)" size="mini" type="primary">立即购买</el-button>
                    </div>
                </div>
                <div class="dr-company flex">
                    <div class="drc-left">
                        <img v-if="item.design_comp && item.design_comp.logo" 
                            :src="IMG_URL_PRE+item.design_comp.logo+'!width_250px'">
                        <img v-else :src="STATIC_URL_PRE+'design/placeholder/zhanweilogo%402x.jpg!width_250px'">
                    </div>
                    <div class="drc-right flex-1">
                        <div v-if="item.design_comp" class="name">
                            <b>{{item.design_comp.name}}</b>
                        </div>
                        <div class="label-wrap flex">
                            <label class="color-1">家具设计</label>
                            <label class="color-2">3D渲染</label>
                            <!-- <Label v-for="(item, i) in compInfo.aptitude.ability_service.range"
                                :key="i" :name="item.v"/> -->
                        </div>
                        <div>
                            <el-button @click="toAptitude(item.design_comp.id)" size="mini" type="primary">查看资质</el-button>
                        </div>
                    </div>
                </div>
                <div v-if="list && list.length>0" class="dr-recommend">
                    <div class="drr-head flex flex-align-center">
                        <img src="@/assets/images/factory/icon_jian.png" alt="">
                        <span>推荐套系</span>
                    </div>
                    <div class="drr-list">
                        <div class="list-item flex" v-for="(item,idx) in list" :key="idx">
                            <div @click="gotoDetail(item.id)" class="list-item-img" v-if="item.photos && item.photos.length>0">
                                <img :src="IMG_URL_PRE+item.photos[0]+'!width_250px'" alt="">
                            </div>
                            <div class="list-item-info flex-1">
                                <div class="name ellipsis2">
                                    <b>{{item.name}}</b>
                                </div>
                                <div class="cat">
                                    <span v-if="item.style">{{item.style.name}}</span>
                                    <!-- <span v-if="item.style && item.cat"> | </span>
                                    <span v-if="item.cat">{{item.cat.name}}</span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog width="500px" @close="refreshItem" :title="popTitle" :visible.sync="popVisible" :destroy-on-close="true">
            <div v-if="popTitle == '签约'">
                <Sign :popTitle="popTitle" @data="refreshItem" @signState="signState" @hide="hide"></Sign>
            </div>
            <div v-if="popTitle == '遇到问题'">
                <SignBack :popTitle="popTitle" @hide="popVisible=false"></SignBack>
            </div>
            <div v-if="popTitle == '请选择签约人'">
                <SignSelect :popTitle="popTitle" :user_id="seal_user_id" :sealMember="sealMember" @hide="popVisible=false" @success="buy"></SignSelect>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { IMG_URL_PRE,STATIC_URL_PRE } from '@/config';
import { listSealMember, buySet, contractAddr, contractView, testHt } from '@/service/contract';
import { marketDetailSet, marketListSet } from '@/service/factory';
import ItemImages from '@/components/ItemImages.vue';
import Sign from '@/components/sign/sign.vue';
import SignBack from '@/components/sign/signBack.vue';
import SignSelect from '@/components/sign/SignSelect.vue';
export default {
    components: { 
        ItemImages,
        Sign, SignBack, SignSelect
    },
    data() {
        return {
            IMG_URL_PRE,
            STATIC_URL_PRE,
            popTitle: null,
            popVisible: false,
            item: null,
            tabList:[
                // { name: "未分类", }
            ],
            tabIndex:0,
            opt: {
                    page: 1,
                    pagesize: 5,
                },
            list:[],
            loading: null,
            type: "", // 1从版权购买订单进来
            seal_user_id: null, // 合同签约人ID
            sealMember: [], // 合同签约人列表
        }
    },
    watch: {
        $route(to,from){
            this.refreshItem();
        }
    },
    created() {
        this.type = this.$route.query.type;
        this.seal_user_id = this.$store.state.loginUser.user.id;
        this.refreshItem();
        this.getRecomment();
    },
    mounted() {},
    methods: {
        gotoProduct(id) { // 查看商品详情
            this.$router.push("/factory/market/single/detail/"+id+"?setType=1"+"&s="+this.item.trans_stat);
        },
        toAptitude(id) { // 查看资质
            window.open('/zizhi/view/'+id);
        },
        gotoDetail(id) { // 查看推荐套系
            this.$router.push("/factory/market/series/detail/"+id);
        },
        // 选项卡
        tab(index) {
            this.tabIndex = index;
            console.log(index);
        },
        refreshItem() { // 获取数据
            console.log('refreshItem');
            const _loading = this.$loading({
                lock: true,
                text: '拼命加载中......',
                target: this.$refs.load
            });
            marketDetailSet(this.$route.params.id).then(res => {
                this.item = res;
                this.tabList = [];
                let list = [];
                if (this.item.product_rows && this.item.product_rows.length>0) {
                    this.item.product_rows.forEach(e => {
                        list.push(e);
                    });
                }
                if (this.item.sub_set_rows && this.item.sub_set_rows.length>0) {
                    this.tabList = this.item.sub_set_rows;
                    this.item.sub_set_rows.forEach(e => {
                        if (e.product_rows && e.product_rows.length>0) {
                            e.product_rows.forEach(n=>{
                                list.push(n);
                            })
                        }
                    });
                }
                this.tabList.unshift({
                    id: this.item.id,
                    parent_set_no: "",
                    name: "未分类", 
                    product_rows: this.item.product_rows
                })
                this.tabList.unshift({
                    id: 0,
                    parent_set_no: "",
                    name: "全部", 
                    product_rows: list
                })
                console.log(this.item,this.tabList);
                _loading.close();
            }).catch(err => {
                console.log(err);
                this.$message.error(err.message);
                _loading.close();
            });
        },
        getRecomment() {
            marketListSet(this.opt).then(rst => {
                this.list = rst.list;
                console.log('getRecomment',this.list);
            }).catch(err => {
                console.log(err);
                this.$message.error(err.message);
            });
        },
        contract_view(item) { // 查看合同
            if (item.contract_no) {
                window.open(contractView(item.contract_no));
            } else {
                let obj = {
                    contract_title:"设计版权购买合同",
                    content_file: item.contract_file,
                    custom_cover_page: item.custom_cover_page,
                }
                if (item.price_type==0) {
                    obj.contract_title = "设计版权购买合同";
                } else if (item.price_type==3) {
                    obj.contract_title = "需求定制合同";
                } else {
                    obj.contract_title = "合同标题";
                }
                if (obj.content_file) {
                    window.open(testHt(obj));
                }
            }
        },
        gotoSign() {
            if (this.$store.state.loginUser.comp.cert_stat!=2) {
                this.$message.error("企业未认证");
                return;
            } else {
                this.$confirm('确认是否发起签约?', '温馨提示', { confirmButtonText: '确定',
                cancelButtonText: '取消',closeOnClickModal: false, type: 'warning',
                }).then(() => {
                    let obj = {
                        seal_type: 1, // 印章类型，0保留，1设计作品版权出售合同章，2商品打样合同章，3代加工合同章
                        page: 1,
                        pagesize: 15
                    }
                    listSealMember(obj).then(res=>{
                        if (res && res.list && res.list.length>0) {
                            this.sealMember = res.list;
                            this.selectSign();
                        } else {
                            this.buy();
                        }
                    }).catch(err=>{
                        this.$message.error(err.message);
                    });
                    // this.buy();
                    
                });
            }
        },
        selectSign() {
            this.popTitle = '请选择签约人';
            this.popVisible = true;
        },
        buy(user_id) {
            console.log(user_id);
            this.loading = this.$loading({
                fullscreen: true, text: '拼命加载中....',
                target:this.$refs.load
            });
            buySet(this.item.id).then(rst=>{
                if (user_id) {
                    this.going(rst.contract_no,user_id);
                } else {
                    this.going(rst.contract_no);
                }
            }).catch(err=>{
                this.$message.error(err.message);
                this.loading.close();
            });
        },
        going(contract_no,seal_user_id) {
            // let invsec = 30;
            // let timer = setInterval((e) => {
            //     contractAddr(contract_no).then(rst=>{
            //         console.log("rst",rst);
            //         if (rst && rst.url) {
            //             this.sign(rst.url);
            //             clearInterval(timer);
            //             return;
            //         }
            //     }).catch(err=>{
            //         // this.$message.error(err.message);
            //         this.loading.close();
            //     });
            //     // if (invsec == 0) {
            //     //     // this.goCgdd();
            //     //     window.location.href="about:blank";
            //     //     window.close();
            //     //     clearInterval(timer);
            //     //     return;
            //     // }
            //     // invsec--;
            // }, 2000);
            contractAddr(contract_no,seal_user_id).then(rst=>{
                console.log("rst",rst);
                if (rst && rst.url) {
                    //激发标签点击事件OVER
                    // let ev = document.createEvent("MouseEvents");
                    // ev.initEvent("click", true, true);
                    // var a = document.getElementById("aHref");
                    // a.href = rst.url;
                    // a.dispatchEvent(ev);
                    window.open(rst.url);
                    this.signState("签约");
                    this.loading.close();
                }
            }).catch(err=>{
                // this.$message.error(err.message);
                this.loading.close();
            });
        },
        hide() {
            this.popVisible = false;
            this.$message.success('状态已更新');
        },
        signState(text) {
            this.popTitle = text;
            this.popVisible = true;
        },
    }
}
</script>
<style scoped src="../../style.css"></style>
<style scoped lang="less">
.container {
    width: 1200px;
    margin: 0 auto;
}
.detail-left {
    margin-right: 20px;
}
.detail-top {
    padding: 20px;
    background: #fff;
    border: 1px solid #E6E6E6;
    margin-bottom: 20px;
    .top {
        padding-bottom: 20px;
        .info-img {
            width: 36px;
            height: 36px;
            background: #5074EE;
            border-radius: 6px;
            overflow: hidden;
            margin-right: 12px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .info-name {
            font-size: 18px;
            color: #292929;
            line-height: 25px;
            margin-bottom: 4px;
        }
        .style {
            font-size: 14px;
            color: #4D4D4D;
        }
    }
    .bottom {
        padding: 20px 50px 0;
        border-top: 1px solid #E6E6E6;
        >div {
            font-size: 14px;
            color: #4D4D4D;
            margin-right: 45px;
            >img {
                height: 30px;
                margin-right: 12px;
            }
        }
    }
}
.detail-bottom {
    background: #fff;
    border: 1px solid #E6E6E6;
    margin-bottom: 40px;
    .tab_menu {
        padding: 0 20px;
        height: 50px;
        border-bottom: 1px solid #E6E6E6;
        .menu_item {
            height: 50px;
            line-height: 50px;
            margin-right: 40px;
            cursor: pointer;
            font-size: 16px;
            font-weight: 500;
            color: #4D4D4D;
            &.cur {
                color: #5074EE;
                border-bottom: 2px solid #5074EE;
            }
        }
    }
    .db-box {
        padding: 10px;
        .dbb-item {
            width: 212px;
            border: 1px solid #E6E6E6;
            margin: 10px;
            cursor: pointer;
            img {
                width: 210px;
                height: 210px;
            }
            .text {
                margin: 12px;
                font-size: 16px;
                color: #292929;
                line-height: 22px;
            }
        }
    }
}
.detail-right {
   width: 320px;
   .dr-info {
       padding: 20px;
       background: #fff;
       border: 1px solid #E6E6E6;
       position: relative;
       margin-bottom: 20px;
        >div {
            font-size: 14px;
            color: #808080;
            line-height: 20px;
            margin-bottom: 12px;
            &:last-child {
                margin-bottom: 0;
            }
            >span {
                color: #4D4D4D;
            }
        }
        .price {
            font-size: 18px;
            color: #F66F6A;
        }
        .contract_view {
            position: absolute;
            top: 10px; right: 20px;
        }
   }
   .dr-company {
       padding: 20px;
       background: #fff;
       border: 1px solid #E6E6E6;
       position: relative;
       margin-bottom: 20px;
       .drc-left {
           width: 32px;
           height: 32px;
           border-radius: 50%;
           overflow: hidden;
           margin-right: 12px;
           img {
               width: 100%;
               height: 100%;
           }
       }
       .name {
           font-size: 14px;
           color: #4D4D4D;
           line-height: 20px;
           margin-bottom: 12px;
       }
       .label-wrap {
            margin-bottom: 12px;
            label {
                padding: 0 8px;
                height:24px;
                line-height: 24px;
                border-radius:12px;
                margin-right: 12px;
                &.color-1 {
                    color: #F66F6A;
                    background:linear-gradient(180deg,rgba(255,178,150,0.2) 0%,rgba(253,136,149,0.2) 100%);
                }
                &.color-2 {
                    color: #2BBAAE;
                    background:linear-gradient(180deg,rgba(70,184,165,0.2) 0%,rgba(154,235,193,0.2) 100%);
                }
            }
        }
   }
   .dr-recommend {
        padding: 20px;
        background: #fff;
        border: 1px solid #E6E6E6;
        position: relative;
        margin-bottom: 20px;
        .drr-head {
            font-size: 18px;
            color: #292929;
            margin-bottom: 18px;
            img {
                width: 25px;
                height: 25px;
                margin-right: 6px;
            }
        }
        .drr-list .list-item {
            background: #FAFAFA;
            border: 1px solid #E6E6E6;
            margin-bottom: 12px;
            &:last-child {
                margin-bottom: 0;
            }
            .list-item-img {
                width: 100px;
                height: 100px;
                margin-right: 12px;
                cursor: pointer;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .list-item-info {
                padding: 16px 0;
                .name {
                   font-size: 16px;
                   color: #292929;
                   margin-bottom: 8px;
                }
                .cat {
                    font-size: 12px;
                    color: #B3B3B3;
                    line-height: 16px;
                }
            }
        }
   }
}
</style>